import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_MEMBERS = 'FETCH_MEMBERS'
export const FETCH_MEMBERS_SUCCESS = 'FETCH_MEMBERS_SUCCESS'
export const FETCH_MEMBERS_FAILURE = 'FETCH_MEMBERS_FAILURE'
export const SAVE_MEMBERS_SUCCESS = 'SAVE_MEMBERS_SUCCESS'
export const SAVE_MEMBERS_FAILURE = 'SAVE_MEMBERS_FAILURE'
export const MEMBERS_AJAX_CALL = 'MEMBERS_AJAX_CALL'
export const MEMBERS_CLEAR_AJAX_CALL = 'MEMBERS_CLEAR_AJAX_CALL'
export const DELETE_MEMBERS_SUCCESS = 'DELETE_MEMBERS_SUCCESS'
export const DELETE_MEMBERS_FAILURE = 'DELETE_MEMBERS_FAILURE'
export const MEMBERS_START_UPLOAD = 'MEMBERS_START_UPLOAD'
export const MEMBERS_STOP_UPLOAD = 'MEMBERS_STOP_UPLOAD'
export const SET_LAST_PAID = 'SET_LAST_PAID'
export const EXPORT_MEMBERS = 'EXPORT_MEMBERS'
export const EXPORT_MEMBERS_SUCCESS = 'EXPORT_MEMBERS_SUCCESS'
export const EXPORT_MEMBERS_FAILURE = 'EXPORT_MEMBERS_FAILURE'

export function loadMembers() {
  return (dispatch) => {
    dispatch(fetchMembers())
    axios({
      method: 'GET',
      url: URIS.members,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchMembersSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchMembersFailure(errorMessage(error)))
      })
  }
}

function fetchMembers() {
  return {
    type: FETCH_MEMBERS
  }
}

function fetchMembersSuccess(payload) {
  return {
    type: FETCH_MEMBERS_SUCCESS,
    payload
  }
}

function fetchMembersFailure(payload) {
  return {
    type: FETCH_MEMBERS_FAILURE,
    payload
  }
}

export function saveMembers(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.members,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveMembersSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveMembersFailure(errorMessage(error)))
      })
  }
}

function saveMembersSuccess(payload) {
  return {
    type: SAVE_MEMBERS_SUCCESS,
    payload
  }
}

export function saveMembersFailure(payload) {
  return {
    type: SAVE_MEMBERS_FAILURE,
    payload
  }
}

export function deleteMembers(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'DELETE',
      url: URIS.members,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(deleteMembersSuccess(res.data.data))
      })
      .catch((error) => {
        dispatch(deleteMembersFailure(errorMessage(error)))
      })
  }
}

function deleteMembersSuccess(payload) {
  return {
    type: DELETE_MEMBERS_SUCCESS,
    payload
  }
}

export function deleteMembersFailure(payload) {
  return {
    type: DELETE_MEMBERS_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: MEMBERS_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: MEMBERS_CLEAR_AJAX_CALL
  }
}

export function startUpload() {
  return {
    type: MEMBERS_START_UPLOAD
  }
}

export function stopUpload() {
  return {
    type: MEMBERS_STOP_UPLOAD
  }
}

export function setMemberLastPaid(payload) {
  return {
    type: SET_LAST_PAID,
    payload
  }
}

export function loadExportMembers(payload) {
  return (dispatch) => {
    dispatch(exportMembers())
    axios({
      method: 'POST',
      url: URIS.export,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(exportMembersSuccess(res.data))
      })
      .catch((error) => {
        dispatch(exportMembersFailure(errorMessage(error)))
      })
  }
}

function exportMembers() {
  return {
    type: EXPORT_MEMBERS
  }
}

function exportMembersSuccess(payload) {
  return {
    type: EXPORT_MEMBERS_SUCCESS,
    payload
  }
}

function exportMembersFailure(payload) {
  return {
    type: EXPORT_MEMBERS_FAILURE,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/Members.js